import { render, staticRenderFns } from "./packageConfig.vue?vue&type=template&id=47c3f58a&"
import script from "./packageConfig.vue?vue&type=script&lang=js&"
export * from "./packageConfig.vue?vue&type=script&lang=js&"
import style0 from "./packageConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports